/**
 * Landing Preview feature — entry point (~40 lines)
 *
 * Structure:
 *   hooks/useLandingData.js  ← fetches all 6 CMS endpoints + hero carousel state
 *   constants.js             ← static fallback data + asset imports
 *   sections/index.jsx       ← all 7 section presentational components
 *   sections/HeroSectionPreview.jsx ← hero carousel with AnimatePresence
 */
import { RiPlayFill, RiPauseFill, RiExternalLinkLine } from 'react-icons/ri'
import { useLandingData } from './hooks/useLandingData.js'
import HeroSectionPreview from './sections/HeroSectionPreview.jsx'
import {
  AboutSectionPreview,
  ClientSectionPreview,
  ScheduleSectionPreview,
  FacilitiesSectionPreview,
  TeamSectionPreview,
  GallerySectionPreview,
  CTASectionPreview,
  ContactSectionPreview,
  FooterPreview,
} from './sections/index.jsx'

export default function LandingPreviewPage() {
  const {
    heroImages, aboutImages, clientLogos, kelasData, teamImages, galleryImages,
    heroIdx, setHeroIdx, flashing,
    playing, togglePlay,
  } = useLandingData()

  return (
    <div className="space-y-0 -mx-6 -mt-8 md:-mx-8">
      {/* Header bar — outside the negative margin */}
      <div className="px-6 pb-4 pt-0 md:px-8 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">Tampilan Landing Page</h2>
          <p className="mt-0.5 text-sm text-gray-500">
            Tampilan website LPK Asa Hikari Mulya dengan data dari CMS.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={togglePlay}
            className="inline-flex items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-sm font-medium text-gray-600 hover:border-gray-300 hover:bg-gray-50 transition-colors shadow-sm"
          >
            {playing ? <RiPauseFill className="text-base" /> : <RiPlayFill className="text-base" />}
            {playing ? 'Pause Hero' : 'Play Hero'}
          </button>
          <a
            href={import.meta.env.VITE_PUBLIC_SITE || '/'}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 rounded-lg bg-blue-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-blue-700 transition-colors shadow-sm"
          >
            <RiExternalLinkLine />
            Buka Website Asli
          </a>
        </div>
      </div>

      {/* All sections — 1:1 with real landing page */}
      <HeroSectionPreview
        heroImages={heroImages}
        heroIdx={heroIdx}
        setHeroIdx={setHeroIdx}
        flashing={flashing}
        playing={playing}
        togglePlay={togglePlay}
      />
      <AboutSectionPreview aboutImages={aboutImages} />
      <ClientSectionPreview clientLogos={clientLogos} />
      <ScheduleSectionPreview kelasData={kelasData} />
      <FacilitiesSectionPreview />
      <TeamSectionPreview teamImages={teamImages} />
      <GallerySectionPreview galleryImages={galleryImages} />
      <CTASectionPreview />
      <ContactSectionPreview />
      <FooterPreview />
    </div>
  )
}
